<div>
  Normally you should not see this, authenticated ==
  {{ authenticated().isAuthenticated }}
</div>
